module.exports = __webpack_public_path__ + "img/watermark-gray.40065850.png";